
import React from "react";
import { MessageCircle } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { useNotificationChatStatus } from "@/hooks/useNotificationChatStatus";
import { cn } from "@/lib/utils";

interface ChatStatusIndicatorProps {
  notificationId: string;
  className?: string;
}

const ChatStatusIndicator = ({ notificationId, className }: ChatStatusIndicatorProps) => {
  const { totalMessages, unreadMessages, hasMessages, isLoading } = useNotificationChatStatus(notificationId);
  
  // If no messages or still loading, don't show anything
  if (isLoading || !hasMessages) return null;
  
  // Determine if there are unread messages
  const hasUnread = unreadMessages > 0;
  
  return (
    <div className={cn("relative inline-flex items-center", className)}>
      <MessageCircle 
        className={cn(
          "h-4 w-4",
          hasUnread ? "text-green-500" : "text-gray-500"
        )} 
      />
      {totalMessages > 0 && (
        <Badge 
          variant="secondary" 
          className={cn(
            "absolute -top-2 -right-2 h-4 min-w-4 flex items-center justify-center rounded-full text-[10px] px-1 py-0",
            hasUnread 
              ? "bg-green-100 text-green-800 border border-green-300" 
              : "bg-gray-100 text-gray-700 border border-gray-300"
          )}
        >
          {hasUnread ? unreadMessages : totalMessages}
        </Badge>
      )}
    </div>
  );
};

export default ChatStatusIndicator;
